import { render, staticRenderFns } from "./Reclamation.vue?vue&type=template&id=15656b2b&"
import script from "./reclamation.js?vue&type=script&lang=js&"
export * from "./reclamation.js?vue&type=script&lang=js&"
import style0 from "./reclamation.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports